import { render } from "./Form.vue?vue&type=template&id=0d44f5aa&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=0d44f5aa&lang=scss&scoped=true"

import exportComponent from "C:\\Dev\\Vue\\intensione\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d44f5aa"]])

export default __exports__